export default [
	{
		topicName: 'Array',
		position: 0,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Array",
				"Problem": "Reverse the array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/write-a-program-to-reverse-an-array-or-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-the-array_1262298"
			},
			{
				"Topic": "Array",
				"Problem": "Find the maximum and minimum element in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-minimum-and-maximum-element-in-an-array4428/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sum-of-max-and-min_1081476"
			},
			{
				"Topic": "Array",
				"Problem": "Find the \"Kth\" max and min element of an array ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/kth-largest-element-in-an-array/",
				"URL2": "https://practice.geeksforgeeks.org/problems/kth-smallest-element/0"
			},
			{
				"Topic": "Array",
				"Problem": "Given an array which consists of only 0, 1 and 2. Sort the array without using any sorting algo",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/sort-colors/",
				"URL2": "https://practice.geeksforgeeks.org/problems/sort-an-array-of-0s-1s-and-2s/0"
			},
			{
				"Topic": "Array",
				"Problem": "Move all the negative elements to one side of the array ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/move-all-negative-elements-to-end1813/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/move-all-negative-numbers-to-beginning-and-positive-to-end_1112620"
			},
			{
				"Topic": "Array",
				"Problem": "Find the Union and Intersection of the two sorted arrays.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/union-of-two-arrays/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-similarities-between-two-arrays_1229070"
			},
			{
				"Topic": "Array",
				"Problem": "Write a program to cyclically rotate an array by one.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/rotate-array/",
				"URL2": "https://practice.geeksforgeeks.org/problems/cyclically-rotate-an-array-by-one/0"
			},
			{
				"Topic": "Array",
				"Problem": "find Largest sum contiguous Subarray [V. IMP]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-subarray/",
				"URL2": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0"
			},
			{
				"Topic": "Array",
				"Problem": "Minimise the maximum difference between heights [V.IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimize-the-heights3351/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimize-the-difference_3208652"
			},
			{
				"Topic": "Array",
				"Problem": "Minimum no. of Jumps to reach end of an array",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/jump-game-ii/",
				"URL2": "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0"
			},
			{
				"Topic": "Array",
				"Problem": "find duplicate in an array of N+1 Integers",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-the-duplicate-number/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-in-array_893397"
			},
			{
				"Topic": "Array",
				"Problem": "Merge 2 sorted arrays without using Extra space.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-sorted-array/",
				"URL2": "https://practice.geeksforgeeks.org/problems/merge-two-sorted-arrays-1587115620/1"
			},
			{
				"Topic": "Array",
				"Problem": "Kadane's Algo [V.V.V.V.V IMP]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-subarray/",
				"URL2": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0"
			},
			{
				"Topic": "Array",
				"Problem": "Merge Intervals",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-intervals/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-intervals_699917"
			},
			{
				"Topic": "Array",
				"Problem": "Next Permutation",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/next-permutation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/next-permutaion_893046"
			},
			{
				"Topic": "Array",
				"Problem": "Count Inversion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-inversions_615"
			},
			{
				"Topic": "Array",
				"Problem": "Best time to buy and Sell stock",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stocks-are-profitable_893405"
			},
			{
				"Topic": "Array",
				"Problem": "find all pairs on integer array whose sum is equal to given number",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/two-sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/count-pairs-with-given-sum5022/1"
			},
			{
				"Topic": "Array",
				"Problem": "find common elements In 3 sorted arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/common-elements1132/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/common-elements-in-three-sorted-arrays_1113130"
			},
			{
				"Topic": "Array",
				"Problem": "Rearrange the array in alternating positive and negative items with O(1) extra space",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/rearrange-array-elements-by-sign/",
				"URL2": "https://practice.geeksforgeeks.org/problems/array-of-alternate-ve-and-ve-nos1401/1"
			},
			{
				"Topic": "Array",
				"Problem": "Find if there is any subarray with sum equal to 0",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subarray-with-0-sum/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subset-sum-equal-to-k_1550954"
			},
			{
				"Topic": "Array",
				"Problem": "Find factorial of a large number",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/factorials-of-large-numbers/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/factorial-of-a-large-number_1115471"
			},
			{
				"Topic": "Array",
				"Problem": "find maximum product subarray ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-product-subarray/",
				"URL2": "https://practice.geeksforgeeks.org/problems/maximum-product-subarray3604/1"
			},
			{
				"Topic": "Array",
				"Problem": "Find longest consecutive subsequence",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-consecutive-sequence/",
				"URL2": "https://practice.geeksforgeeks.org/problems/longest-consecutive-subsequence/0"
			},
			{
				"Topic": "Array",
				"Problem": "Given an array of size n and a number k, find all elements that appear more than \" n/k \" times.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/majority-element-ii/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/elements-occur-more-than-n-k-times_1113146"
			},
			{
				"Topic": "Array",
				"Problem": "Maximum profit by buying and selling a share atmost twice",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iii/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/buy-and-sell-stock_1071012"
			},
			{
				"Topic": "Array",
				"Problem": "Find whether an array is a subset of another array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/array-subset-of-another-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-subset_762948"
			},
			{
				"Topic": "Array",
				"Problem": "Find the triplet that sum to a given value",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/3sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/triplet-sum-in-array/0"
			},
			{
				"Topic": "Array",
				"Problem": "Trapping Rain water problem",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/trapping-rain-water/",
				"URL2": "https://practice.geeksforgeeks.org/problems/trapping-rain-water/0"
			},
			{
				"Topic": "Array",
				"Problem": "Chocolate Distribution problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/chocolate-problem_893280"
			},
			{
				"Topic": "Array",
				"Problem": "Smallest Subarray with sum greater than a given value",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-size-subarray-sum/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rahul-and-minimum-subarray_1551987"
			},
			{
				"Topic": "Array",
				"Problem": "Three way partitioning of an array around a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/three-way-partitioning/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/three-way-partition_1170519"
			},
			{
				"Topic": "Array",
				"Problem": "Minimum swaps required bring elements less equal K together",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps-required-to-bring-all-elements-less-than-or-equal-to-k-together/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-bring-all-elements-less-than-or-equal-to-k-together_1112657"
			},
			{
				"Topic": "Array",
				"Problem": "Minimum no. of operations required to make an array palindrome",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-number-of-moves-to-make-palindrome/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/make-it-palindrome_3189160"
			},
			{
				"Topic": "Array",
				"Problem": "Median of 2 sorted arrays of equal size",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/median-of-two-sorted-arrays/",
				"URL2": "https://www.geeksforgeeks.org/median-of-two-sorted-arrays/"
			},
			{
				"Topic": "Array",
				"Problem": "Median of 2 sorted arrays of different size",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/median-of-two-sorted-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-of-two-sorted-arrays_985294"
			}
		],
	},
	{
		topicName: 'Matrix',
		position: 1,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Matrix",
				"Problem": "Spiral traversal on a Matrix",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/spiral-matrix/",
				"URL2": "https://practice.geeksforgeeks.org/problems/spirally-traversing-a-matrix/0"
			},
			{
				"Topic": "Matrix",
				"Problem": "Search an element in a matriix",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/search-a-2d-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/search-in-a-row-wise-and-column-wise-sorted-matrix_839811"
			},
			{
				"Topic": "Matrix",
				"Problem": "Find median in a row wise sorted matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/median-in-a-row-wise-sorted-matrix1527/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-in-matrix_981178"
			},
			{
				"Topic": "Matrix",
				"Problem": "Find row with maximum no. of 1's",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/row-with-maximum-ones/",
				"URL2": "https://practice.geeksforgeeks.org/problems/row-with-max-1s0023/1"
			},
			{
				"Topic": "Matrix",
				"Problem": "Print elements in sorted order using row-column wise sorted matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sorted-matrix/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sorted-matrix_758931"
			},
			{
				"Topic": "Matrix",
				"Problem": "Maximum size rectangle",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximal-rectangle/",
				"URL2": "https://practice.geeksforgeeks.org/problems/max-rectangle/1"
			},
			{
				"Topic": "Matrix",
				"Problem": "Find a specific pair in matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-a-specific-pair-in-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-a-specific-pair-in-the-matrix_1115467"
			},
			{
				"Topic": "Matrix",
				"Problem": "Rotate matrix by 90 degrees",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/rotate-image/",
				"URL2": "https://www.geeksforgeeks.org/rotate-a-matrix-by-90-degree-in-clockwise-direction-without-using-any-extra-space/"
			},
			{
				"Topic": "Matrix",
				"Problem": "Kth smallest element in a row-column wise sorted matrix",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/kth-smallest-element-in-a-sorted-matrix/",
				"URL2": "https://practice.geeksforgeeks.org/problems/kth-element-in-matrix/1"
			},
			{
				"Topic": "Matrix",
				"Problem": "Common elements in all rows of a given matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/common-elements-in-all-rows-of-a-given-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/common-elements-present-in-all-rows-of-a-matrix_1118111"
			}
		],
	},
	{
		topicName: 'String',
		position: 2,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "String",
				"Problem": "Reverse a String",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reverse-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/string-reverse_3210207"
			},
			{
				"Topic": "String",
				"Problem": "Check whether a String is Palindrome or not",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/valid-palindrome/",
				"URL2": "https://practice.geeksforgeeks.org/problems/palindrome-string0817/1"
			},
			{
				"Topic": "String",
				"Problem": "Find Duplicate characters in a string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-all-the-duplicates-in-the-input-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-characters_3189116"
			},
			{
				"Topic": "String",
				"Problem": "Why strings are immutable in Java?",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.baeldung.com/java-string-immutable",
				"URL2": ""
			},
			{
				"Topic": "String",
				"Problem": "Write a Code to check whether one string is a rotation of another",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/rotate-string/",
				"URL2": "https://www.geeksforgeeks.org/a-program-to-check-if-strings-are-rotations-of-each-other/"
			},
			{
				"Topic": "String",
				"Problem": "Write a Program to check whether a string is a valid shuffle of two strings or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.programiz.com/java-programming/examples/check-valid-shuffle-of-strings",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shuffle-two-strings_1115692"
			},
			{
				"Topic": "String",
				"Problem": "Count and Say problem",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/count-and-say/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/write-as-you-speak_1090543"
			},
			{
				"Topic": "String",
				"Problem": "Write a program to find the longest Palindrome in a string.[ Longest palindromic Substring]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-palindromic-substring/",
				"URL2": "https://practice.geeksforgeeks.org/problems/longest-palindrome-in-a-string/0"
			},
			{
				"Topic": "String",
				"Problem": "Find Longest Recurring Subsequence in String",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-repeating-subsequence_1062697"
			},
			{
				"Topic": "String",
				"Problem": "Print all Subsequences of a string.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-subsequences-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subsequences-of-string_985087"
			},
			{
				"Topic": "String",
				"Problem": "Print all the permutations of the given string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/print-permutations-string_758958"
			},
			{
				"Topic": "String",
				"Problem": "Split the Binary string into two substring with equal 0’s and 1’s",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/split-the-binary-string-into-substrings-with-equal-number-of-0s-and-1s/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-array-of-0s-and-1s_2656186"
			},
			{
				"Topic": "String",
				"Problem": "Word Wrap Problem [VERY IMP].",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-wrap/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-wrap_982931"
			},
			{
				"Topic": "String",
				"Problem": "EDIT Distance [Very Imp]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/edit-distance/",
				"URL2": "https://practice.geeksforgeeks.org/problems/edit-distance3702/1"
			},
			{
				"Topic": "String",
				"Problem": "Find next greater number with same set of digits. [Very Very IMP]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/next-permutation/",
				"URL2": "https://practice.geeksforgeeks.org/problems/next-permutation/0"
			},
			{
				"Topic": "String",
				"Problem": "Balanced Parenthesis problem.[Imp]",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/valid-parentheses/",
				"URL2": "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0"
			},
			{
				"Topic": "String",
				"Problem": "Word break Problem[ Very Imp]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/word-break/",
				"URL2": "https://practice.geeksforgeeks.org/problems/word-break/0"
			},
			{
				"Topic": "String",
				"Problem": "Rabin Karp Algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/rabin-karp-algorithm-for-pattern-searching/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stringmatch-rabincarp_1115738"
			},
			{
				"Topic": "String",
				"Problem": "KMP Algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-prefix-suffix2527/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-pattern-in-string_1112621"
			},
			{
				"Topic": "String",
				"Problem": "Convert a Sentence into its equivalent mobile numeric keypad sequence.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-sentence-equivalent-mobile-numeric-keypad-sequence/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-sentence_1115490"
			},
			{
				"Topic": "String",
				"Problem": "Minimum number of bracket reversals needed to make an expression balanced.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-the-reversals/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-to-make-string-valid_1115770"
			},
			{
				"Topic": "String",
				"Problem": "Count All Palindromic Subsequence in a given String.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-palindrome-words-in-a-sentence_975378"
			},
			{
				"Topic": "String",
				"Problem": "Count of number of given string in 2D character array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-count-number-given-string-present-2d-character-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-strings_1118116"
			},
			{
				"Topic": "String",
				"Problem": "Search a Word in a 2D Grid of characters.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-the-string-in-grid/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-search_630520"
			},
			{
				"Topic": "String",
				"Problem": "Boyer Moore Algorithm for Pattern Searching.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/boyer-moore-algorithm-for-pattern-searching/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/boyer-moore-algorithm-for-pattern-searching_1115634"
			},
			{
				"Topic": "String",
				"Problem": "Converting Roman Numerals to Decimal",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/roman-to-integer/",
				"URL2": "https://practice.geeksforgeeks.org/problems/roman-number-to-integer/0"
			},
			{
				"Topic": "String",
				"Problem": "Longest Common Prefix",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-common-prefix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-prefix_2090383"
			},
			{
				"Topic": "String",
				"Problem": "Number of flips to make binary string alternate",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/min-number-of-flips/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/beautiful-string_1115625"
			},
			{
				"Topic": "String",
				"Problem": "Find the first repeated word in string.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-first-repeated-word-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/second-most-repeated-word_3210218"
			},
			{
				"Topic": "String",
				"Problem": "Minimum number of swaps for bracket balancing.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps-for-bracket-balancing/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-number-of-swaps-for-bracket-balancing_1115682"
			},
			{
				"Topic": "String",
				"Problem": "Find the longest common subsequence between two strings.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-common-subsequence/",
				"URL2": "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0"
			},
			{
				"Topic": "String",
				"Problem": "Program to generate all possible valid IP addresses from given  string.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/restore-ip-addresses/",
				"URL2": "https://www.geeksforgeeks.org/program-generate-possible-valid-ip-addresses-given-string/"
			},
			{
				"Topic": "String",
				"Problem": "Write a program to find the smallest window that contains all characters of string itself.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-distant-window/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shortest-substring-with-all-characters_704894"
			},
			{
				"Topic": "String",
				"Problem": "Rearrange characters in a string such that no two adjacent are same",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reorganize-string/",
				"URL2": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1"
			},
			{
				"Topic": "String",
				"Problem": "Minimum characters to be added at front to make string palindrome",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/shortest-palindrome/",
				"URL2": "https://www.geeksforgeeks.org/minimum-characters-added-front-make-string-palindrome/"
			},
			{
				"Topic": "String",
				"Problem": "Given a sequence of words, print all anagrams together",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/group-anagrams/",
				"URL2": "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0"
			},
			{
				"Topic": "String",
				"Problem": "Find the smallest window in a string containing all characters of another string",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-window-substring/",
				"URL2": "https://practice.geeksforgeeks.org/problems/smallest-window-in-a-string-containing-all-the-characters-of-another-string/0"
			},
			{
				"Topic": "String",
				"Problem": "Recursively remove all adjacent duplicates",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/remove-all-adjacent-duplicates-in-string/",
				"URL2": "https://practice.geeksforgeeks.org/problems/consecutive-elements/0"
			},
			{
				"Topic": "String",
				"Problem": "String matching where one string contains wildcard characters",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/wildcard-matching/",
				"URL2": "https://practice.geeksforgeeks.org/problems/wildcard-string-matching/0"
			},
			{
				"Topic": "String",
				"Problem": "Function to find Number of customers who could not get a computer",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/function-to-find-number-of-customers-who-could-not-get-a-computer/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-customers-who-did-not-get-a-computer_1115775"
			},
			{
				"Topic": "String",
				"Problem": "Transform One String to Another using Minimum Number of Given Operation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/transform-one-string-to-another-using-minimum-number-of-given-operation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-shift-operations_1115784"
			},
			{
				"Topic": "String",
				"Problem": "Check if two given strings are isomorphic to each other",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/isomorphic-strings/",
				"URL2": "https://practice.geeksforgeeks.org/problems/isomorphic-strings/0"
			},
			{
				"Topic": "String",
				"Problem": "Recursively print all sentences that can be formed from list of word lists",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/recursively-print-all-sentences-that-can-be-formed-from-list-of-word-lists/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-sentences_1123512"
			}
		],
	},
	{
		topicName: 'Search & Sort',
		position: 3,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find first and last positions of an element in a sorted array",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-first-and-last-position-of-element-in-sorted-array/",
				"URL2": "https://practice.geeksforgeeks.org/problems/first-and-last-occurrences-of-x/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find a Fixed Point (Value equal to index) in a given array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/value-equal-to-index-value1330/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/value-equal-to-the-index-value_1115771"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Search in a rotated sorted array",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/search-in-rotated-sorted-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/search-in-rotated-sorted-array_1082554"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "square root of an integer",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/sqrtx/",
				"URL2": "https://practice.geeksforgeeks.org/problems/count-squares3649/1"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Maximum and minimum of an array using minimum number of comparisons",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-and-minimum-in-an-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/middle-of-three_1118283"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Optimum location of point to minimize total distance",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/optimum-location-point-minimize-total-distance/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/optimum-location_1116097"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find the repeating and the missing",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/set-mismatch/",
				"URL2": "https://practice.geeksforgeeks.org/problems/find-missing-and-repeating2512/1"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "find majority element",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/majority-element/",
				"URL2": "https://practice.geeksforgeeks.org/problems/majority-element/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Searching in an array where adjacent differ by at most k",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/searching-in-an-array-where-adjacent-differ-by-at-most-k0456/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-student_3161883"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "find a pair with a given difference",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-pair-given-difference/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/pair-difference-k_1089634"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "find four elements that sum to a given value",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/4sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/find-all-four-sum-numbers/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "maximum sum such that no 2 elements are adjacent",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/house-robber/",
				"URL2": "https://practice.geeksforgeeks.org/problems/stickler-theif/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Count triplet with sum smaller than a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-triplets-with-sum-smaller-than-x5549/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/3-sum-smaller_3161884"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "merge 2 sorted arrays",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-sorted-array/",
				"URL2": "https://www.geeksforgeeks.org/merge-two-sorted-arrays/"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "print all subarrays with 0 sum",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/zero-sum-subarrays/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subarrays-with-zero-sum_3161876"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Product array Puzzle",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/product-of-array-except-self/",
				"URL2": "https://practice.geeksforgeeks.org/problems/product-array-puzzle/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Sort array according to count of set bits",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-by-set-bit-count/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-an-array-according-to-the-count-of-set-bits_873142"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "minimum no. of swaps required to sort the array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-sort-array_1806885"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Bishu and Soldiers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/problem/algorithm/bishu-and-soldiers-227/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/search-in-the-array_1116099"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Rasta and Kheshtak",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/rasta-and-kheshtak/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-his-sword_1164268"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Kth smallest number again",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/kth-smallest-number-again-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-integer-in-ranges_1115609"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find pivot element in a sorted array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "http://theoryofprogramming.com/2017/12/16/find-pivot-element-sorted-rotated-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/game-of-largest-element_1170064"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "K-th Element of Two Sorted Arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/k-th-element-of-two-sorted-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-element-of-2-sorted-array_1164159"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Aggressive cows",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/magnetic-force-between-two-balls/",
				"URL2": "https://www.spoj.com/problems/AGGRCOW/"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Book Allocation Problem",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/split-array-largest-sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "EKOSPOJ:",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/EKO/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kevin-and-his-fruits_1164267"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Job Scheduling Algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/weighted-job-scheduling-log-n-time/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/weighted-job-scheduling_1094885"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Missing Number in AP",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/arithmetic-number/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/missing-number-in-ap_975498"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Smallest number with atleastn trailing zeroes infactorial",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-factorial-number5929/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/smallest-number-with-at-least-n-trailing-zeros-in-factorial_1115774"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Painters Partition Problem:",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/split-array-largest-sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "ROTI-Prata SPOJ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/PRATA/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cooking-ninjas_1164174"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "DoubleHelix SPOJ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/ANARC05B/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximize-the-sum_1118624"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Subset Sums",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/SUBSUMS/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/city-of-happy-people_1199336"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find the inversion count",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/equal-global-and-local-inversions_1463976"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Implement Merge-sort in-place",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/in-place-merge-sort/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-sort-in-place_1118623"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Partitioning and Sorting Arrays with Many Repeated Entries",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.baeldung.com/java-sorting-arrays-with-repeated-entries",
				"URL2": "https://www.codingninjas.com/codestudio/problems/partitioning-and-sorting-arrays-with-many-repeated-entries_1170515"
			}
		],
	},
	{
		topicName: 'Linked List',
		position: 4,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "LinkedList",
				"Problem": "Write a Program to reverse the Linked List. (Both Iterative and recursive)",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reverse-linked-list/",
				"URL2": "https://www.geeksforgeeks.org/reverse-a-linked-list/"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Reverse a Linked List in group of Given Size. [Very Imp]",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reverse-nodes-in-k-group/",
				"URL2": "https://practice.geeksforgeeks.org/problems/reverse-a-linked-list-in-groups-of-given-size/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a program to Detect loop in a linked list.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/linked-list-cycle/",
				"URL2": "https://practice.geeksforgeeks.org/problems/detect-loop-in-linked-list/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a program to Delete loop in a linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/remove-loop-in-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/detect-and-remove-cycle_920523"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find the starting point of the loop. ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/linked-list-cycle-ii/",
				"URL2": "https://www.geeksforgeeks.org/find-first-node-of-loop-in-a-linked-list/"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Remove Duplicates in a sorted Linked List.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/remove-duplicates-from-sorted-list/",
				"URL2": "https://practice.geeksforgeeks.org/problems/remove-duplicate-element-from-sorted-linked-list/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Remove Duplicates in a Un-sorted Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/remove-duplicates-from-an-unsorted-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/remove-duplicates-from-unsorted-linked-list_1069331"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a Program to Move the last element to Front in a Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/move-last-element-to-front-of-a-given-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/deleting-and-adding-the-last-node_1170051"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Add “1” to a number represented as a Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/add-1-to-a-number-represented-as-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/add-one-to-linked-list_920456"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Add two numbers represented by linked lists.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/add-two-numbers/",
				"URL2": "https://practice.geeksforgeeks.org/problems/add-two-numbers-represented-by-linked-lists/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Intersection of two Sorted Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/intersection-of-two-sorted-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/intersection-of-linked-lists_3210610"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Intersection Point of two Linked Lists.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/intersection-of-two-linked-lists/",
				"URL2": "https://practice.geeksforgeeks.org/problems/intersection-point-in-y-shapped-linked-lists/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Merge Sort For Linked lists.[Very Important]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/sort-list/",
				"URL2": "https://practice.geeksforgeeks.org/problems/sort-a-linked-list/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Quicksort for Linked Lists.[Very Important]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/quick-sort-on-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/quick-sort-on-linked-list_893099"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find the middle Element of a linked list.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/middle-of-the-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/middle-of-linked-list_973250"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Check if a linked list is a circular linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/circular-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-it-a-circular-linked-list_981265"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Split a Circular linked list into two halves.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/split-a-circular-linked-list-into-two-halves/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/split-a-circular-linked-list_1071003"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a Program to check whether the Singly Linked list is a palindrome or not.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/palindrome-linked-list/",
				"URL2": "https://practice.geeksforgeeks.org/problems/check-if-linked-list-is-pallindrome/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Deletion from a Circular Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/deletion-and-reverse-in-linked-list/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/deletion-in-circular-linked-list_630409"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Reverse a Doubly Linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-a-doubly-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-a-doubly-linked-list_1116098"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find pairs with a given sum in a DLL.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-pairs-given-sum-doubly-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-pair-with-a-given-sum-in-a-doubly-linked-list_1164172"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Count triplets in a sorted DLL whose sum is equal to given value “X”.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/count-triplets-sorted-doubly-linked-list-whose-sum-equal-given-value-x/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-triplets_873377"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Sort a “k”sorted Doubly Linked list.[Very IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.codingninjas.com/codestudio/problems/sort-a-k-sorted-doubly-linked-list_1118118",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-a-k-sorted-doubly-linked-list_1118118"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Rotate DoublyLinked list by N nodes.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/rotate-doubly-linked-list-n-nodes/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rotate-dll_1115782"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Rotate a Doubly Linked list in group of Given Size.[Very IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/reverse-doubly-linked-list-groups-given-size/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-dll-nodes-in-groups_920399"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Can we reverse a linked list in less than O(n) ?",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/can-we-reverse-a-linked-list-in-less-than-on/",
				"URL2": ""
			},
			{
				"Topic": "LinkedList",
				"Problem": "Why Quicksort is preferred for. Arrays and Merge Sort for LinkedLists ?",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/why-quick-sort-preferred-for-arrays-and-merge-sort-for-linked-lists/",
				"URL2": ""
			},
			{
				"Topic": "LinkedList",
				"Problem": "Flatten a Linked List",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/flattening-a-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flatten-a-linked-list_1112655"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Sort a LL of 0's, 1's and 2's",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/given-a-linked-list-of-0s-1s-and-2s-sort-it/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-linked-list-of-0s-1s-2s_1071937"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Clone a linked list with next and random pointer",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/copy-list-with-random-pointer/",
				"URL2": "https://practice.geeksforgeeks.org/problems/clone-a-linked-list-with-next-and-random-pointer/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Merge K sorted Linked list",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-k-sorted-lists/",
				"URL2": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Multiply 2 no. represented by LL",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/multiply-two-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/multiply-linked-lists_983603"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Delete nodes which have a greater value on right side",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/remove-nodes-from-linked-list/",
				"URL2": "https://practice.geeksforgeeks.org/problems/delete-nodes-having-greater-value-on-right/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Segregate even and odd nodes in a Linked List",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/odd-even-linked-list/",
				"URL2": "https://practice.geeksforgeeks.org/problems/segregate-even-and-odd-nodes-in-a-linked-list/0"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Program for n’th node from the end of a Linked List",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/remove-nth-node-from-end-of-list/",
				"URL2": "https://practice.geeksforgeeks.org/problems/nth-node-from-end-of-linked-list/1"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find the first non-repeating character from a stream of characters",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-unique-character-in-a-string_893404"
			}
		],
	},
	{
		topicName: 'Binary Trees',
		position: 5,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Binary Trees",
				"Problem": "level order traversal",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-level-order-traversal/",
				"URL2": "https://practice.geeksforgeeks.org/problems/level-order-traversal/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Reverse Level Order traversal",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-level-order-traversal-ii/",
				"URL2": "https://practice.geeksforgeeks.org/problems/reverse-level-order-traversal/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Height of a tree",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-depth-of-binary-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/height-of-binary-tree/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Diameter of a tree",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/diameter-of-binary-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/diameter-of-binary-tree/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Mirror of a tree",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/invert-binary-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-binary-tree-to-mirror-tree_873140"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Inorder Traversal of a tree both using recursion and Iteration",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-inorder-traversal/",
				"URL2": "https://www.techiedelight.com/inorder-tree-traversal-iterative-recursive/"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Preorder Traversal of a tree both using recursion and Iteration",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-preorder-traversal/",
				"URL2": "https://www.techiedelight.com/preorder-tree-traversal-iterative-recursive/"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Postorder Traversal of a tree both using recursion and Iteration",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-postorder-traversal/",
				"URL2": "https://www.techiedelight.com/postorder-tree-traversal-iterative-recursive/"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Left View of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/left-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/left-view-of-a-binary-tree_920519"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Right View of Tree",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-right-side-view/",
				"URL2": "https://practice.geeksforgeeks.org/problems/right-view-of-binary-tree/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Top View of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/top-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/top-view-of-the-tree_799401"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Bottom View of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bottom-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bottom-view-of-binary-tree_893110"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Zig-Zag traversal of a binary tree",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/binary-tree-zigzag-level-order-traversal/",
				"URL2": "https://practice.geeksforgeeks.org/problems/zigzag-tree-traversal/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if a tree is balanced or not",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/balanced-binary-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/check-for-balanced-tree/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Diagonal Traversal of a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/diagonal-traversal-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/diagonal-traversal_893029"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Boundary traversal of a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/boundary-traversal-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/boundary-traversal_790725"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Construct Binary Tree from String with Bracket Representation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/construct-binary-tree-from-string-with-bracket-representation/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/binary-tree-from-bracket_1118117"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Convert Binary tree into Doubly Linked List",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/binary-tree-to-dll/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bst-to-sorted-dll_1263694"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Convert Binary tree into Sum tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/transform-to-sum-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-a-binary-tree-to-its-sum-tree_920395"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Construct Binary tree from Inorder and preorder traversal",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/",
				"URL2": "https://practice.geeksforgeeks.org/problems/construct-tree-1/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find minimum swaps required to convert a Binary tree into BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-swap-required-convert-binary-tree-binary-search-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-convert-binary-tree-into-bst_1118109"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if Binary tree is Sum tree or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sum-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-binary-tree-is-sum-tree-or-not_1164404"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if all leaf nodes are at same level or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/leaf-at-same-level/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/level-leaf_3210614"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if a Binary Tree contains duplicate subtrees of size 2 or more [ IMP ]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-duplicate-subtrees/",
				"URL2": "https://practice.geeksforgeeks.org/problems/duplicate-subtree-in-binary-tree/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if 2 trees are mirror or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-mirror-in-n-ary-tree/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-for-mirror-trees_3125887"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Sum of Nodes on the Longest path from root to leaf node ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sum-of-the-longest-bloodline-of-a-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-path_3210613"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if given graph is tree or not.  [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/check-given-graph-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-graph-tree_1115787"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find Largest subtree sum in a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-largest-subtree-sum-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-subtree-sum_1082330"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Maximum Sum of nodes in Binary tree such that no two are adjacent ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/house-robber-iii/",
				"URL2": "https://www.geeksforgeeks.org/maximum-sum-nodes-binary-tree-no-two-adjacent/"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Print all \"K\" Sum paths in a Binary tree",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/path-sum-iii/",
				"URL2": "https://www.geeksforgeeks.org/print-k-sum-paths-binary-tree/"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find LCA in a Binary tree",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-binary-tree/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find distance between 2 nodes in a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/min-distance-between-two-given-nodes-of-a-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/distance-between-two-nodes-of-a-tree_800303"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Kth Ancestor of node in a Binary tree",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/kth-ancestor-of-a-tree-node/",
				"URL2": "https://www.geeksforgeeks.org/kth-ancestor-node-binary-tree-set-2/"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find all Duplicate subtrees in a Binary tree [ IMP ]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-duplicate-subtrees/",
				"URL2": "https://practice.geeksforgeeks.org/problems/duplicate-subtrees/1"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Tree Isomorphism Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-if-tree-is-isomorphic/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/isomorphic-trees_794946"
			}
		],
	},
	{
		topicName: 'BST',
		position: 6,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find a value in a BST",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/search-in-a-binary-search-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/search-a-node-in-bst/1/"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Deletion of a node in a BST",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/delete-node-in-a-bst/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/delete-node-in-bst_920381"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find min and max value in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-element-in-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/guess-price_3211264"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find inorder successor and inorder predecessor in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/_893049"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Check if a tree is a BST or not ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/validate-binary-search-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/check-for-bst/1"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Populate Inorder successor of all nodes",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/populate-inorder-successor-for-all-nodes/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/populate-inorder-successor-of-all-nodes-of-a-binary-tree_1118625"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find LCA  of 2 nodes in a BST",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-search-tree/",
				"URL2": "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-bst/1"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Construct BST from preorder traversal",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/construct-binary-search-tree-from-preorder-traversal/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bst-from-preorder_2689307"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Convert Binary tree into BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/binary-tree-to-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/binary-tree-to-bst_893074"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Convert a normal BST into a Balanced BST",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/balance-a-binary-search-tree/",
				"URL2": "https://www.geeksforgeeks.org/convert-normal-bst-balanced-bst/"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Merge two BST [ V.V.V>IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/merge-two-balanced-binary-search-trees/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/h_920474"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find Kth largest element in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kth-largest-element-in-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-largest-number_920438"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find Kth smallest element in a BST",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/kth-smallest-element-in-a-bst/",
				"URL2": "https://practice.geeksforgeeks.org/problems/find-k-th-smallest-element-in-bst/1"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Count pairs from 2 BST whose sum is equal to given value \"X\"",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/brothers-from-different-root/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-couples_3208653"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find the median of BST in O(n) time and O(1) space",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-median-bst-time-o1-space/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-of-a-bst_893184"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Count BST nodes that lie in a given range",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-bst-nodes-that-lie-in-a-given-range/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bst-queries_1095658"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Replace every element with the least greater element on its right",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/replace-every-element-with-the-least-greater-element-on-its-right/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/least-greater-element_1164266"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Given \"n\" appointments, find the conflicting appointments",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/given-n-appointments-find-conflicting-appointments/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-conflicting-meetings_1170047"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Check preorder is valid or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/preorder-to-postorder/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-preorder-traversal-is-valid_1164410"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Check whether BST contains Dead end",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-whether-bst-contains-dead-end/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-for-dead-end-in-a-bst_1169457"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Largest BST in a Binary Tree [ V.V.V.V.V IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/largest-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/largest-bst-subtree_893103"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Flatten BST to sorted list",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/increasing-order-search-tree/",
				"URL2": "https://www.geeksforgeeks.org/flatten-bst-to-sorted-list-increasing-order/"
			}
		],
	},
	{
		topicName: 'Greedy',
		position: 7,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Greedy",
				"Problem": "Activity Selection Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/activity-selection-1587115620/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-activities_1062712"
			},
			{
				"Topic": "Greedy",
				"Problem": "Job Sequencing Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/job-sequencing-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/job-sequencing-problem_1169460"
			},
			{
				"Topic": "Greedy",
				"Problem": "Huffman Coding",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/huffman-encoding/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/huffman-coding_1169467"
			},
			{
				"Topic": "Greedy",
				"Problem": "Water Connection Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/water-connection-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-weight-in-a-connected-component_1170508"
			},
			{
				"Topic": "Greedy",
				"Problem": "Fractional Knapsack Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/fractional-knapsack/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/fractional-knapsack_975286"
			},
			{
				"Topic": "Greedy",
				"Problem": "Greedy Algorithm to find Minimum number of Coins",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/coin-change/",
				"URL2": "https://practice.geeksforgeeks.org/problems/coin-piles/0"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximum trains for which stoppage can be provided",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-trains-stoppage-can-provided/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-trains-for-which-stoppage-can-be-provided_1169456"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum Platforms Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-platforms/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-number-of-platforms_799400"
			},
			{
				"Topic": "Greedy",
				"Problem": "Buy Maximum Stocks if i stocks can be bought on i-th day",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/buy-maximum-stocks-stocks-can-bought-th-day/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-shares_3114365"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find the minimum and maximum amount to buy all N candies",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/shop-in-candy-store/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-and-maximum-cost-to-buy-n-candies_975298"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimize Cash Flow among a given set of friends who have borrowed money from each other",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimize-cash-flow-among-a-given-set-of-friends-who-have-borrowed-money-from-each-other_1170048"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum Cost to cut a board into squares",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-cost-cut-board-squares/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/board-cutting_975500"
			},
			{
				"Topic": "Greedy",
				"Problem": "Check if it is possible to survive on Island",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/survival/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-possible-to-survive_1170052"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find maximum meetings in one room",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-maximum-meetings-in-one-room/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-meetings_1062658"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximum product subset of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-product-subset-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/max-product-subset_1170054"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximize array sum after K negations",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximize-sum-of-array-after-k-negations/",
				"URL2": "https://practice.geeksforgeeks.org/problems/maximize-sum-after-k-negations/0"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximize the sum of arr[i]*i",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximize-arrii-of-an-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum_2824971"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximum sum of absolute difference of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-sum-absolute-difference-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-absolute-difference_1164175"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximize sum of consecutive differences in a circular array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/swap-and-maximize/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/swap-and-maximise_1164405"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum sum of absolute difference of pairs of two arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-sum-absolute-difference-pairs-two-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-difference_1164402"
			},
			{
				"Topic": "Greedy",
				"Problem": "Program for Shortest Job First (or SJF) CPU Scheduling",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/program-for-shortest-job-first-or-sjf-cpu-scheduling-set-1-non-preemptive/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sjf_1172165"
			},
			{
				"Topic": "Greedy",
				"Problem": "Program for Least Recently Used (LRU) Page Replacement algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/page-faults-in-lru/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/page-faults_2826682"
			},
			{
				"Topic": "Greedy",
				"Problem": "Smallest subset with sum greater than all other elements",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/smallest-subset-sum-greater-elements/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-smallest-subset-of-balls-whose-weight-is-greater-than-the-weight-of-remaining-balls_1170530"
			},
			{
				"Topic": "Greedy",
				"Problem": "Chocolate Distribution Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "DEFKIN -Defense of a Kingdom",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/DEFKIN/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "DIEHARD -DIE HARD",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/DIEHARD/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "GERGOVIA -Wine trading in Gergovia",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/GERGOVIA/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "Picking Up Chicks",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/GCJ101BB/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "CHOCOLA –Chocolate",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/CHOCOLA/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "ARRANGE -Arranging Amplifiers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/ARRANGE/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "K Centers Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/k-centers-problem-set-1-greedy-approximate-algorithm/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-centers_1280117"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum Cost of ropes",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/connect-n-ropes-with-minimum-cost_630476"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find smallest number with given number of digits and sum of digits",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-number5829/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/smallest-number_1164401"
			},
			{
				"Topic": "Greedy",
				"Problem": "Rearrange characters in a string such that no two adjacent are same",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reorganize-string/",
				"URL2": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find maximum sum possible equal sum of three stacks",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-maximum-sum-possible-equal-sum-three-stacks/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-equal-sum-stack_1164270"
			}
		],
	},
	{
		topicName: 'BackTracking',
		position: 8,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "BackTracking",
				"Problem": "Rat in a maze Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rat-in-a-maze_1215030"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Printing all solutions in N-Queen Problem",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/n-queens/",
				"URL2": "https://www.geeksforgeeks.org/printing-solutions-n-queen-problem/"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Word Break Problem using Backtracking",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/word-break/",
				"URL2": "https://practice.geeksforgeeks.org/problems/word-break-part-2/0"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Remove Invalid Parentheses",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/remove-invalid-parentheses/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/generate-all-valid-strings_1170524"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Sudoku Solver",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/sudoku-solver/",
				"URL2": "https://practice.geeksforgeeks.org/problems/solve-the-sudoku/0"
			},
			{
				"Topic": "BackTracking",
				"Problem": "m Coloring Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/m-coloring-problem_981273"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Print all palindromic partitions of a string",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/palindrome-partitioning/",
				"URL2": "https://www.geeksforgeeks.org/given-a-string-print-all-possible-palindromic-partition/"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Subset Sum Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/partition-equal-subset-sum_892980"
			},
			{
				"Topic": "BackTracking",
				"Problem": "The Knight’s tour problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/the-knights-tour-problem-backtracking-1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/knight-tour_1170518"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Tug of War",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/tug-of-war/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/tug-of-war_985253"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find shortest safe route in a path with landmines",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-shortest-safe-route-in-a-path-with-landmines/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shortest-safe-route-in-a-field-with-landmines_1164264"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Combinational Sum",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/combination-sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/combination-sum/0"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find Maximum number possible by doing at-most K swaps",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/largest-number-in-k-swaps/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-maximum-number-possible-by-doing-at-most-k-swaps_1169469"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Print all permutations of a string ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
				"URL2": ""
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find if there is a path of more than k length from a source",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-if-there-is-a-path-of-more-than-k-length-from-a-source_1229512"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Longest Possible Route in a Matrix with Hurdles",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/longest-possible-route-in-a-matrix-with-hurdles/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-route_1170525"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Print all possible paths from top left to bottom right of a mXn matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-all-possible-paths-from-top-left-to-bottom-right-of-a-mxn-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/print-all-possible-paths-from-top-left-corner-to-bottom-right-corner-of-a-2-d-matrix_1171152"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Partition of a set intoK subsets with equal sum",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/partition-to-k-equal-sum-subsets/",
				"URL2": "https://practice.geeksforgeeks.org/problems/partition-array-to-k-subsets/1"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find the K-th Permutation Sequence of first N natural numbers",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/permutation-sequence/",
				"URL2": "https://www.geeksforgeeks.org/find-the-k-th-permutation-sequence-of-first-n-natural-numbers/"
			}
		],
	},
	{
		topicName: 'Stacks & Queues',
		position: 9,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Stacks & Queues",
				"Problem": " Implement Stack from Scratch",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.tutorialspoint.com/javaexamples/data_stack.htm",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stack-implementation-using-array_3210209"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": " Implement Queue from Scratch",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/queue-set-1introduction-and-array-implementation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/queue-using-array-or-singly-linked-list_2099908"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement 2 stack in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/implement-two-stacks-in-an-array/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/two-stacks_983634"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "find the middle element of a stack",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/design-a-stack-with-find-middle-operation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/delete-middle-element-from-stack_985246"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement \"N\" stacks in an Array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/efficiently-implement-k-stacks-single-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/n-stacks-in-an-array_1164271"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Check the expression has valid or Balanced parenthesis or not.",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/valid-parentheses/",
				"URL2": "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse a String using Stack",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reverse-string/",
				"URL2": "https://practice.geeksforgeeks.org/problems/reverse-a-string-using-stack/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Design a Stack that supports getMin() in O(1) time and O(1) extra space.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/min-stack/",
				"URL2": "https://practice.geeksforgeeks.org/problems/special-stack/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Find the next Greater element",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/next-greater-element-i/",
				"URL2": "https://practice.geeksforgeeks.org/problems/next-larger-element/0"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "The celebrity Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/the-celebrity-problem/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/the-celebrity-problem_982769"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Arithmetic Expression evaluation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/arithmetic-expression-evalution/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/arithmetic-expression-evaluation_1170517"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Evaluation of Postfix expression",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/evaluate-reverse-polish-notation/",
				"URL2": "https://practice.geeksforgeeks.org/problems/evaluation-of-postfix-expression/0"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement a method to insert an element at its bottom without using any other data structure.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/program-to-insert-an-element-at-the-bottom-of-a-stack/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/insert-an-element-at-its-bottom-in-a-given-stack_1171166"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse a stack using recursion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/reverse-a-stack-using-recursion/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-stack-using-recursion_631875"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Sort a Stack using recursion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-a-stack/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-a-stack_985275"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Merge Overlapping Intervals",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-intervals/",
				"URL2": "https://practice.geeksforgeeks.org/problems/8a644e94faaa94968d8665ba9e0a80d1ae3e0a2d/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Largest rectangular Area in Histogram",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/largest-rectangle-in-histogram/",
				"URL2": "https://practice.geeksforgeeks.org/problems/maximum-rectangular-area-in-a-histogram/0"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Length of the Longest Valid Substring",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-valid-parentheses/",
				"URL2": "https://practice.geeksforgeeks.org/problems/valid-substring0624/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Expression contains redundant bracket or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/expression-contains-redundant-bracket-not/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-a-complex-expression_1170758"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement Stack using Queue",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/implement-stack-using-queues/",
				"URL2": "https://practice.geeksforgeeks.org/problems/stack-using-two-queues/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement Stack using Deque",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/implement-stack-queue-using-deque/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stack-using-deque_1170512"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Stack Permutations (Check if an array is stack permutation of other)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/stack-permutations-check-if-an-array-is-stack-permutation-of-other/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/valid-stack-permutation_1170061"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement Queue using Stack  ",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/implement-queue-using-stacks/",
				"URL2": "https://practice.geeksforgeeks.org/problems/queue-using-two-stacks/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement \"n\" queue in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/efficiently-implement-k-queues-single-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/n-queue-using-array_1170053"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement a Circular queue",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/design-circular-queue/",
				"URL2": "https://www.geeksforgeeks.org/circular-queue-set-1-introduction-array-implementation/"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "LRU Cache Implementationa",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/lru-cache/",
				"URL2": "https://practice.geeksforgeeks.org/problems/lru-cache/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse a Queue using recursion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/queue-reversal/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reversing-queue_1170046"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse the first “K” elements of a queue",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-first-k-elements-of-queue/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-the-first-k-elements-of-a-queue_1164269"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Interleave the first half of the queue with second half",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/interleave-first-half-queue-second-half/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/interleave-the-first-half-of-the-queue-with-the-second-half_1169450"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Find the first circular tour that visits all Petrol Pumps",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/gas-station/",
				"URL2": "https://practice.geeksforgeeks.org/problems/circular-tour/1"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Minimum time required to rot all oranges",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/rotting-oranges/",
				"URL2": "https://practice.geeksforgeeks.org/problems/rotten-oranges/0"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Distance of nearest cell having 1 in a binary matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/distance-of-nearest-cell-having-1/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/distance-of-nearest-cell-having-1-in-a-binary-matrix_1169913"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "First negative integer in every window of size “k”",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-negative-integer-in-every-window-of-size-k/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-negative-integer-in-every-window-of-size-k_1164406"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Check if all levels of two trees are anagrams or not.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/check-if-all-levels-of-two-trees-are-anagrams-or-not/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-all-levels-of-two-trees-are-anagrams-of-each-other-not_1214546"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Sum of minimum and maximum elements of all subarrays of size “k”.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/sum-minimum-maximum-elements-subarrays-size-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sum-of-minimum-and-maximum-elements-of-all-subarrays-of-size-k_1171047"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Minimum sum of squares of character counts in a given string after removing “k” characters.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/game-with-string/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-sum-of-squares_1170763"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Queue based approach or first non-repeating character in a stream.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-unique-character-in-a-string_982933"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Next Smaller Element",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/next-smaller-element/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/next-smaller-element_1112581"
			}
		],
	},
	{
		topicName: 'Heap',
		position: 10,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Heap",
				"Problem": "Implement a Maxheap/MinHeap using arrays and recursion.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/building-heap-from-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/build-min-heap_1171167"
			},
			{
				"Topic": "Heap",
				"Problem": "Sort an Array using heap. (HeapSort)",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/sort-an-array/",
				"URL2": "https://www.geeksforgeeks.org/heap-sort/"
			},
			{
				"Topic": "Heap",
				"Problem": "Maximum of all subarrays of size k.",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/sliding-window-maximum/",
				"URL2": "https://www.geeksforgeeks.org/sliding-window-maximum-maximum-of-all-subarrays-of-size-k/"
			},
			{
				"Topic": "Heap",
				"Problem": "“k” largest element in an array",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/kth-largest-element-in-an-array/",
				"URL2": "https://practice.geeksforgeeks.org/problems/k-largest-elements4206/1"
			},
			{
				"Topic": "Heap",
				"Problem": "Kth smallest and largest element in an unsorted array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/kth-smallestlargest-element-unsorted-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-element-in-an-unsorted-array_1170531"
			},
			{
				"Topic": "Heap",
				"Problem": "Merge “K” sorted arrays. [ IMP ]",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-k-sorted-lists/",
				"URL2": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-arrays/1"
			},
			{
				"Topic": "Heap",
				"Problem": "Merge 2 Binary Max Heaps",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-two-binary-max-heap/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-two-binary-max-heaps_1170049"
			},
			{
				"Topic": "Heap",
				"Problem": "Kth largest sum continuous subarrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/k-th-largest-sum-contiguous-subarray/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-largest-sum-contiguous-subarray_920398"
			},
			{
				"Topic": "Heap",
				"Problem": "Leetcode- reorganize strings",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reorganize-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rearrange-the-array_975383"
			},
			{
				"Topic": "Heap",
				"Problem": "Merge “K” Sorted Linked Lists [V.IMP]",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-k-sorted-lists/",
				"URL2": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1"
			},
			{
				"Topic": "Heap",
				"Problem": "Smallest range in “K” Lists",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/smallest-range-covering-elements-from-k-lists/",
				"URL2": "https://practice.geeksforgeeks.org/problems/find-smallest-range-containing-elements-from-k-lists/1"
			},
			{
				"Topic": "Heap",
				"Problem": "Median in a stream of Integers",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-median-from-data-stream/",
				"URL2": "https://practice.geeksforgeeks.org/problems/find-median-in-a-stream/0"
			},
			{
				"Topic": "Heap",
				"Problem": "Check if a Binary Tree is Heap",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/is-binary-tree-heap/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-binary-heap-tree_893136"
			},
			{
				"Topic": "Heap",
				"Problem": "Connect “n” ropes with minimum cost",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
				"URL2": ""
			},
			{
				"Topic": "Heap",
				"Problem": "Convert BST to Min Heap",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-bst-min-heap/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-bst-to-min-heap_920498"
			},
			{
				"Topic": "Heap",
				"Problem": "Convert min heap to max heap",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-min-heap-to-max-heap/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-min-heap-to-max-heap_1381084"
			},
			{
				"Topic": "Heap",
				"Problem": "Rearrange characters in a string such that no two adjacent are same.",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reorganize-string/",
				"URL2": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1"
			},
			{
				"Topic": "Heap",
				"Problem": "Minimum sum of two numbers formed from digits of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-sum4058/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-sum-of-two-numbers-formed-from-digits-of-an-array_1171162"
			}
		],
	},
	{
		topicName: 'Graph',
		position: 11,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Graph",
				"Problem": "Create a Graph, print it",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://1drv.ms/t/s!AqTOHFO77CqEiRua06v1PATyiFg5",
				"URL2": "https://www.codingninjas.com/codestudio/problems/create-a-graph-and-print-it_1214551"
			},
			{
				"Topic": "Graph",
				"Problem": "Create a Graph (for practice)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/print-adjacency-list-1587115620/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/create-a-graph-and-print-it_1214551"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement BFS algorithm ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bfs-in-graph_973002"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement DFS Algo ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/depth-first-traversal-for-a-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/dfs-traversal_630462"
			},
			{
				"Topic": "Graph",
				"Problem": "Detect Cycle in Directed Graph using BFS/DFS Algo ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/course-schedule/",
				"URL2": "https://practice.geeksforgeeks.org/problems/detect-cycle-in-a-directed-graph/1"
			},
			{
				"Topic": "Graph",
				"Problem": "Detect Cycle in UnDirected Graph using BFS/DFS Algo ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cycle-detection-in-undirected-graph_1062670"
			},
			{
				"Topic": "Graph",
				"Problem": "Search in a Maze",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "Minimum Step by Knight",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/steps-by-knight/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-knight-moves_2179628"
			},
			{
				"Topic": "Graph",
				"Problem": "flood fill algo",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/flood-fill/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flood-fill-algorithm_1089687"
			},
			{
				"Topic": "Graph",
				"Problem": "Clone a graph",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/clone-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/clone-graph_1103394"
			},
			{
				"Topic": "Graph",
				"Problem": "Making wired Connections",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/number-of-operations-to-make-network-connected/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-connection-changes_1171168"
			},
			{
				"Topic": "Graph",
				"Problem": "word Ladder ",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/word-ladder/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-ladder_1102319"
			},
			{
				"Topic": "Graph",
				"Problem": "Dijkstra algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/implementing-dijkstra-set-1-adjacency-matrix/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/dijkstra-s-shortest-path_920469"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Topological Sort ",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/course-schedule-ii/",
				"URL2": "https://practice.geeksforgeeks.org/problems/topological-sort/1"
			},
			{
				"Topic": "Graph",
				"Problem": "Minimum time taken by each job to be completed given by a Directed Acyclic Graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-time-taken-by-each-job-to-be-completed-given-by-a-directed-acyclic-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kill-the-snipers-ii_1171163"
			},
			{
				"Topic": "Graph",
				"Problem": "Find whether it is possible to finish all tasks or not from given dependencies",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/course-schedule/",
				"URL2": "https://www.geeksforgeeks.org/find-whether-it-is-possible-to-finish-all-tasks-or-not-from-given-dependencies/"
			},
			{
				"Topic": "Graph",
				"Problem": "Find the no. of Islands",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/number-of-islands/",
				"URL2": "https://practice.geeksforgeeks.org/problems/find-the-number-of-islands/1"
			},
			{
				"Topic": "Graph",
				"Problem": "Given a sorted Dictionary of an Alien Language, find order of characters",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/alien-dictionary/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-alien_1171179"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Kruskal’s Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/kruskals-minimum-spanning-tree-algorithm-greedy-algo-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-spanning-tree_631769"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Prim’s Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/prims-minimum-spanning-tree-mst-greedy-algo-5/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/prim-s-mst_1095633"
			},
			{
				"Topic": "Graph",
				"Problem": "Total no. of Spanning tree in a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/total-number-spanning-trees-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/total-number-of-spanning-trees-in-a-graph_1171196"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Bellman Ford Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/negative-weight-cycle/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bellmon-ford_2041977"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Floyd Warshall Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/implementing-floyd-warshall/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flloyd-warshall_2041979"
			},
			{
				"Topic": "Graph",
				"Problem": "Travelling Salesman Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/travelling-salesman-problem-set-1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/travelling-salesman-problem_1385180"
			},
			{
				"Topic": "Graph",
				"Problem": "Graph Colouring Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/graph-coloring-applications/",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "Snake and Ladders Problem",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/snakes-and-ladders/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/snake-and-ladder_630458"
			},
			{
				"Topic": "Graph",
				"Problem": "Find bridge in a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/bridge-in-a-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bridges-in-graph_893026"
			},
			{
				"Topic": "Graph",
				"Problem": "Count Strongly connected Components(Kosaraju Algo)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/strongly-connected-components-kosarajus-algo/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-strongly-connected-components-kosaraju-s-algorithm_1171151"
			},
			{
				"Topic": "Graph",
				"Problem": "Check whether a graph is Bipartite or Not",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/is-graph-bipartite/",
				"URL2": "https://www.geeksforgeeks.org/bipartite-graph/"
			},
			{
				"Topic": "Graph",
				"Problem": "Detect Negative cycle in a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/detect-negative-cycle-graph-bellman-ford/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/negative-cycle-in-a-directed-graph_1090517"
			},
			{
				"Topic": "Graph",
				"Problem": "Longest path in a Directed Acyclic Graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-longest-path-directed-acyclic-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-path-in-directed-graph_1172157"
			},
			{
				"Topic": "Graph",
				"Problem": "Journey to the Moon",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerrank.com/challenges/journey-to-the-moon/problem",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-fruits_1170757"
			},
			{
				"Topic": "Graph",
				"Problem": "Cheapest Flights Within K Stops",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/cheapest-flights-within-k-stops/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/saving-money_1171195"
			},
			{
				"Topic": "Graph",
				"Problem": "Oliver and the Game",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/practice/algorithms/graphs/topological-sort/practice-problems/algorithm/oliver-and-the-game-3/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/hide-and-seek_1172173"
			},
			{
				"Topic": "Graph",
				"Problem": "Water Jug problem using BFS",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/water-and-jug-problem/",
				"URL2": "https://www.geeksforgeeks.org/water-jug-problem-using-bfs/"
			},
			{
				"Topic": "Graph",
				"Problem": "Find if there is a path of more thank length from a source",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "M-Colouring Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "Minimum edges to reverse to make path from source to destination",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-edges-reverse-make-path-source-destination/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-edges_1200162"
			},
			{
				"Topic": "Graph",
				"Problem": "Paths to travel each nodes using each edge(Seven Bridges)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/paths-travel-nodes-using-edgeseven-bridges-konigsberg/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/euler-path_1214547"
			},
			{
				"Topic": "Graph",
				"Problem": "Vertex Cover Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/vertex-cover-problem-set-1-introduction-approximate-algorithm-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/vertex-cover-problem_1081481"
			},
			{
				"Topic": "Graph",
				"Problem": "Chinese Postman or Route Inspection",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/chinese-postman-route-inspection-set-1-introduction/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-travel-time_1171046"
			},
			{
				"Topic": "Graph",
				"Problem": "Number of Triangles in a Directed and Undirected Graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/number-of-triangles-in-directed-and-undirected-graphs/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/number-of-triangles-in-directed-and-undirected-graphs_1214931"
			},
			{
				"Topic": "Graph",
				"Problem": "Minimise the cashflow among a given set of friends who have borrowed money from each other",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cash-flow_975372"
			},
			{
				"Topic": "Graph",
				"Problem": "Two Clique Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/two-clique-problem-check-graph-can-divided-two-cliques/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/two-cliques_1214524"
			}
		],
	},
	{
		topicName: 'Trie',
		position: 12,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Trie",
				"Problem": "Construct a trie from scratch",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/implement-trie-prefix-tree/",
				"URL2": "https://www.geeksforgeeks.org/trie-insert-and-search/"
			},
			{
				"Topic": "Trie",
				"Problem": "Find shortest unique prefix for every word in a given list",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-all-shortest-unique-prefixes-to-represent-each-word-in-a-given-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shortest-unique-prefix_1094887"
			},
			{
				"Topic": "Trie",
				"Problem": "Word Break Problem | (Trie solution)",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/word-break/",
				"URL2": "https://www.geeksforgeeks.org/word-break-problem-trie-solution/"
			},
			{
				"Topic": "Trie",
				"Problem": "Given a sequence of words, print all anagrams together",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/group-anagrams/",
				"URL2": "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0"
			},
			{
				"Topic": "Trie",
				"Problem": "Implement a Phone Directory",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/phone-directory/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/implement-a-phone-directory_1062666"
			},
			{
				"Topic": "Trie",
				"Problem": "Print unique rows in a given boolean matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/unique-rows-in-boolean-matrix/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/unique-matrix_1214696"
			}
		],
	},
	{
		topicName: 'Dynamic Programming',
		position: 13,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Dynamic Programming",
				"Problem": "Coin ChangeProblem",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/coin-change/",
				"URL2": "https://practice.geeksforgeeks.org/problems/coin-change2448/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Knapsack Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/0-1-knapsack_920542"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Binomial CoefficientProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/ncr1019/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/binomial-coefficient-problem_1229410"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Permutation CoefficientProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/permutation-coefficient/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/permutationcoefficient_1214975"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Program for nth Catalan Number",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/unique-binary-search-trees/",
				"URL2": "https://practice.geeksforgeeks.org/problems/geek-and-his-binary-strings1951/1/"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Matrix Chain Multiplication ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/matrix-chain-multiplication0303/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/matrix-chain-multiplication_975344"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Edit Distance",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/edit-distance/",
				"URL2": "https://practice.geeksforgeeks.org/problems/edit-distance3702/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Subset Sum Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Friends Pairing Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/friends-pairing-problem5425/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/friends-pairing-problem_1214625"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Gold Mine Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/gold-mine-problem2608/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/gold-mine-problem_799363"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Assembly Line SchedulingProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/assembly-line-scheduling-dp-34/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-time-to-cross-all-checkpoints_1214626"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Painting the Fenceproblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/painting-the-fence3727/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-the-fence_3210208"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximize The Cut Segments",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/cutted-segments/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cut-into-segments_1214651"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Common Subsequence",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-common-subsequence/",
				"URL2": "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Repeated Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Increasing Subsequence",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-increasing-subsequence/",
				"URL2": "https://practice.geeksforgeeks.org/problems/longest-increasing-subsequence/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Space Optimized Solution of LCS",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/space-optimized-solution-lcs/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "LCS (Longest Common Subsequence) of three strings",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-common-subsequence/",
				"URL2": "https://practice.geeksforgeeks.org/problems/lcs-of-three-strings/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum Sum Increasing Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-at-the-gym_1112624"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count all subsequences having product less than K",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/count-subsequences-product-less-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-the-number-of-subsequences-having-product-not-more-than-p_1214647"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest subsequence such that difference between adjacent is one",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-subsequence-such-that-difference-between-adjacents-is-one4724/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-subsequence-with-difference-one_1214549"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum subsequence sum such that no three are consecutive",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/max-sum-without-adjacents-2/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-subsequence-sum-such-that-no-three-are-consecutive_1215007"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Egg Dropping Problem",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/super-egg-drop/",
				"URL2": "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum Length Chain of Pairs",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-length-of-pair-chain/",
				"URL2": "https://practice.geeksforgeeks.org/problems/max-length-chain/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum size square sub-matrix with all 1s",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximal-square/",
				"URL2": "https://practice.geeksforgeeks.org/problems/largest-square-formed-in-a-matrix/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum sum of pairs with specific difference",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/pairs-with-specific-difference/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-pairs-with-specific-difference_1230548"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Min Cost PathProblem",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-path-sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/path-in-matrix3805/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum difference of zeros and ones in binary string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-difference-of-zeros-and-ones-in-binary-string4111/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-difference-of-zeros-and-ones-in-a-binary-string_1203919"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Minimum number of jumps to reach end",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/jump-game-ii/",
				"URL2": "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Minimum cost to fill given weight in a bag",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-cost-to-fill-given-weight-in-a-bag1956/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-to-buy-rice_3210212"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Minimum removals from array to make max –min <= K",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-removals-array-make-max-min-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-removals_1214550"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Common Substring",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-common-substring/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-substring_1235207"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count number of ways to reacha given score in a game",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reach-a-given-score/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-his-exam_1214657"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count Balanced Binary Trees of Height h",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bbt-counter/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/number-of-balanced-binary-trees_1062690"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "LargestSum Contiguous Subarray [V>V>V>V IMP ]",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-subarray/",
				"URL2": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Smallest sum contiguous subarray",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/smallest-sum-contiguous-subarray/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-sum-subarray_1062622"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Unbounded Knapsack (Repetition of items allowed)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/knapsack-with-duplicate-items4201/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/unbounded-knapsack_1215029"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Word Break Problem",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/word-break/",
				"URL2": "https://practice.geeksforgeeks.org/problems/word-break/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Largest Independent Set Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/largest-independent-set-problem-dp-26/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Partition problem",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/partition-equal-subset-sum/",
				"URL2": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Palindromic Subsequence",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-palindromic-subsequence/",
				"URL2": "https://practice.geeksforgeeks.org/problems/longest-palindromic-subsequence-1612327878/1/"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count All Palindromic Subsequence in a given String",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-palindromic-subsequences_1062696"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Palindromic Substring",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-palindromic-substring/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest alternating subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-alternating-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-alternating-subsequence_1214645"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Weighted Job Scheduling",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-profit-in-job-scheduling/",
				"URL2": "https://www.geeksforgeeks.org/weighted-job-scheduling/"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Coin game winner where every player has three choices",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/coin-game-winner-every-player-three-choices/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/coin-game-winner-where-every-player-has-three-choices_1229492"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count Derangements (Permutation such that no element appears in its original position) [ IMPORTANT ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/count-derangements-permutation-such-that-no-element-appears-in-its-original-position/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-derangements_1199092"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum profit by buying and selling a share at most twice [ IMP ]",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iii/",
				"URL2": "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Optimal Strategy for a Game",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/predict-the-winner/",
				"URL2": "https://practice.geeksforgeeks.org/problems/optimal-strategy-for-a-game/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Optimal Binary Search Tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/optimal-binary-search-tree-dp-24/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-bst_3210619"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Palindrome PartitioningProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/palindromic-patitioning4845/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/palindromic-partitioning_1063252"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Word Wrap Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-wrap/0",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Mobile Numeric Keypad Problem [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/mobile-numeric-keypad5456/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/mike-and-mobile_1082139"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Boolean Parenthesization Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/boolean-parenthesization/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/problem-name-boolean-evaluation_1214650"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Largest rectangular sub-matrix whose sum is 0",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/largest-rectangular-sub-matrix-whose-sum-0/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sub-matrix-with-sum-zero_1063254"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Largest area rectangular sub-matrix with equal number of 1’s and 0’s [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/largest-area-rectangular-sub-matrix-equal-number-1s-0s/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/largest-sub-matrix-with-equal-0-s-and-1-s_3210616"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum sum rectangle in a 2D matrix",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/max-sum-of-rectangle-no-larger-than-k/",
				"URL2": "https://practice.geeksforgeeks.org/problems/maximum-sum-rectangle/0"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum profit by buying and selling a share at most k times",
				"Difficulty": "Hard",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iv/",
				"URL2": "https://practice.geeksforgeeks.org/problems/maximum-profit4657/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Find if a string is interleaved of two other strings",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/interleaving-string/",
				"URL2": "https://practice.geeksforgeeks.org/problems/interleaved-strings/1"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum Length of Pair Chain",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-length-of-pair-chain/",
				"URL2": ""
			}
		],
	},
	{
		topicName: 'Bit Manipulation',
		position: 14,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Bit Manipulation",
				"Problem": "Count set bits in an integer",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/number-of-1-bits/",
				"URL2": "https://practice.geeksforgeeks.org/problems/set-bits0143/1"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Find the two non-repeating elements in an array of repeating elements",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/single-number-iii/",
				"URL2": "https://practice.geeksforgeeks.org/problems/finding-the-numbers0215/1"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Count number of bits to be flipped to convert A to B",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/hamming-distance/",
				"URL2": "https://practice.geeksforgeeks.org/problems/bit-difference/0"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Count total set bits in all numbers from 1 to n",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/counting-bits/",
				"URL2": "https://practice.geeksforgeeks.org/problems/count-total-set-bits/0"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Program to find whether a no is power of two",
				"Difficulty": "Easy",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/power-of-two/",
				"URL2": "https://practice.geeksforgeeks.org/problems/power-of-2/0"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Find position of the only set bit",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-position-of-set-bit3706/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-lone-set-bit_1062725"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Copy set bits in a range",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/copy-set-bits-in-a-range/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/copy-bits-in-range_3150011"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Divide two integers without using multiplication, division and mod operator",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/divide-two-integers/",
				"URL2": "https://www.geeksforgeeks.org/divide-two-integers-without-using-multiplication-division-mod-operator/"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Calculate square of a number without using *, / and pow()",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/calculate-square-of-a-number-without-using-and-pow/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/calculate-square-of-a-number_1112623"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Power Set",
				"Difficulty": "Medium",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/subsets/",
				"URL2": "https://practice.geeksforgeeks.org/problems/power-set4302/1"
			}
		],
	},
];
export const version = 100000030;
